'use strict';

class Paginator {
    constructor() {
        var paginatorButton = document.querySelector('.paginator');
        if (paginatorButton !== null) {
            paginatorButton.addEventListener('click', (e) => this.readMoreItems(e));
        }
    }
    readMoreItems(e) {
        e.preventDefault();

        var ul = document.querySelector('ul.list__paged');
        this.loadMoreHits(
            e.currentTarget.href,
            (data) => {
                var element = document.createElement('div');
                element.insertAdjacentHTML('beforeend', data.items);
                element = element.querySelectorAll('li');
                [].forEach.call(element, function (item) {
                    ul.appendChild(item);                    
                });
                if (data.nextPageUrl !== null) {
                    e.target.href = data.nextPageUrl;
                }
                else {
                    e.target.parentNode.removeChild(e.target);
                }
                if(element.length > 0) {
                    var focusElement = element[0];
                    focusElement.querySelector('a').focus();                
                }
            });
    }
    
    loadMoreHits(url,callback) {
        var headers= {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'X-Requested-With':'paginator'
        };
        fetch(url,
        {
            headers: headers,
            method: 'GET',
            credentials: 'include'

        }).then(resp => {
            return resp.json();
        }).then(data => {
            callback(data);
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new Paginator();
});

